import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './Redux/store';

ReactDOM.render(
  // <Router basename="/iitdos">
  <Provider store={store}>
  <Router >
    <App />
  </Router>
  </Provider>,
  document.getElementById('root')
);
